import { useState } from "react";
import FileBase64 from "react-file-base64";

export default function App({ files, setFiles, multiple = false, types = [] }) {
  const [reset, setReset] = useState(false);
  return (
    !reset && (
      <FileBase64
        multiple={multiple}
        onDone={(input) => {
          let correcto = true;
          let fileList = [];
          if (multiple == true) {
            fileList = input;
          } else {
            fileList.push(input);
          }

          fileList.forEach((element) => {
            const nameArray = element.name.split(".");
            const ext = String(
              nameArray[nameArray.length - 1]
            ).toLocaleLowerCase();
            if (!types.includes(ext)) {
              correcto = false;
            }
          });
          if (correcto) setFiles(fileList);
          else {
            alert("Uno o mas archivos no son del formato aceptado");
            setReset(true);
            setTimeout(() => {
              setReset(false);
            }, 100);
            setFiles([]);
          }
        }}
      />
    )
  );
}
